import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Flex } from 'reflexbox'
import injectSagas from 'helpers/injectSagas'
import queryString from 'query-string'
import Card from './Card/index'
import Layout from './Layout'
import Panel from './Panel'
import Dialog from './Dialog'

import Chip from './Chip'
import NestedDropdown from './NestedDropdown/Dropdown'

import SearchFieldsCard from './SearchFieldsCard'
import ProductFieldsCard from './ProductFieldsCard'
import RefreshProductListButton from './RefreshButton'
import CollapseIconButton from './CollapseIconButton'
import Collapse from 'components/fulcrum/collapse/Collapse'
import {
  onSelectPublicFilter,
  onSaveClick,
  deleteCustomView
} from 'containers/Project/ElasticSearch/actions'

import {
  mount,
  unmount,
  onFieldButtonClick,
  onSelectCustomView,
  editCustomView,
  setDefaultView,
  resetProductFilters,
  toggleProductHierarchyCollapse
} from './actions'

import {
  MODULE_NAME
} from './constants'

import {
  quickFiltersSelector, 
  customViewsSelector,
  publicCustomViewsStateSelector,
  selectedCustomViewSelector,
  getActivePublicViewStateSelector,
  allDefaultViewSelectors
} from './selectors'

import {
  loadComponentSagas as sagas
} from './sagas'


import styles from './styles.scss'


const mapStateToProps = (state) => {
  return {
    customViews: customViewsSelector(state),
    quickFilters: quickFiltersSelector(state),
    publicViews: publicCustomViewsStateSelector(state),
    selectedView: selectedCustomViewSelector(state),
    selectedPublicView: getActivePublicViewStateSelector(state),
    defaultView: allDefaultViewSelectors(state),
    isProductHierarchyCollapse: state.project.search.collapseProductHierarchy
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mount: (params) => dispatch(mount(params)),
    unmount: () => dispatch(unmount()),
    onSelectPublicFilter: (value) => dispatch(onSelectPublicFilter(value)),
    onSave: () => dispatch(onSaveClick()),
    onButtonClick: () => dispatch(onFieldButtonClick()),
    deleteCustomView: (idx) => dispatch(deleteCustomView(idx)),
    onSelectCustomView: (value) => dispatch(onSelectCustomView(value)),
    editCustomView: (idx) => dispatch(editCustomView(idx)),
    setDefaultView: (idx) => dispatch(setDefaultView(idx)),
    resetProductFilters: () => dispatch(resetProductFilters()),
    toggleProductHierarchyCollapse: () => dispatch(toggleProductHierarchyCollapse())
  }
}

class ProjectSearchPage extends Component {
  componentWillMount() {
    const { location, mount } = this.props
    mount(queryString.parse(location.search))
  }

  componentWillUnmount() {
    this.props.unmount()
  }

  onSelectDropdown(key) {
    if (key === 'addView') {
      this.props.onButtonClick()
    } else {
      this.props.onSelectCustomView(key)
    }
  }

  render() {
    const { 
      onSelectPublicFilter,
      selectedView,
      selectedPublicView,
      publicViews,
      customViews,
      deleteCustomView,
      editCustomView,
      setDefaultView,
      defaultView,
      toggleProductHierarchyCollapse,
      resetProductFilters,
      isProductHierarchyCollapse
    } = this.props
    return (
      <Layout>
        <Panel>
          <Flex 
          wrap
          styleName='chipContainer'
            >
            <NestedDropdown 
              source={customViews}
              onChange={(key) => this.onSelectDropdown(key)}
              deleteCustomView={deleteCustomView}
              editCustomView={editCustomView}
              selected={selectedView}
              defaultView={defaultView}
              publicSource={publicViews}
              setDefaultView={setDefaultView}
            />
            {
              publicViews.map(({ label, value }, idx) => (
                <Chip
                  key={`${value}_chip`}
                  label={label}
                  inverse={(selectedPublicView === value && selectedView === selectedPublicView )}
                  onClick={() => onSelectPublicFilter(value)}
                />
              ))
            }
            <CollapseIconButton
              onClick={toggleProductHierarchyCollapse}
              collapse={isProductHierarchyCollapse}
              message={'Collapse Product Filters'}
            />
            <RefreshProductListButton message={'Refresh All Filters'} onClick={resetProductFilters} />
          </Flex>
          <Flex>
            <Collapse styleName='productContainer' min={0} max={'auto'} collapse={isProductHierarchyCollapse}>
              <ProductFieldsCard />
            </Collapse>
          </Flex>

          <Flex style={{overflow: 'hidden', height: "100%"}}>
            <SearchFieldsCard />
            <Card /> 
          </Flex>
          <Dialog />
        </Panel>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })
const enhance = compose(
  withConnect,
  withSagas,
)

export default enhance(ProjectSearchPage)
